import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { LayoutComponent } from './layout.component'
import { EmptyLayoutModule } from './empty/empty.module'
import { MainLayoutModule } from './main/main.module'

const layoutModules = [
    // Empty
    EmptyLayoutModule,

    // Main
    MainLayoutModule,
]

@NgModule({
    declarations: [LayoutComponent],
    imports: [CommonModule, ...layoutModules],
    exports: [LayoutComponent, ...layoutModules],
})
export class LayoutModule {}
